/* eslint-disable jsx-quotes */
import React, { useEffect, useRef, useState } from 'react';
import MetaSeo from '../MetaSeo';
import 'swiper/css';
import 'swiper/css/pagination';
import Slider from 'react-slick';
import useTrans from '@/hooks/useTrans';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import TextFooter from '../TextFooter';
import FAQ from '../Faq';

function TechnologyGold(props) {
  const trans = useTrans();
  let { seo } = props;
  seo = seo || {};
  const { title_seo, description, text_footer } = seo;
  const ref = useRef();
  const dataSeo = {
    title: title_seo || 'Đồng vàng công nghệ',
    description: description || '',
    image: 'https://hanagold.vn/assets/img/tech/tech-gold-seo.png',
    url: 'https://hanagold.vn/dong-vang-cong-nghe-hanagold',
  };

  const setting = {
    prevArrow: <></>,
    nextArrow: <></>,
    centerPadding: '60px',
  };

  const arr_list_title_faq = [
    trans.tech_gold.products,
    trans.tech_gold.tech,
    trans.tech_gold.policy,
    trans.tech_gold.guide,
  ];

  const arr_detail_fag = [
    [{
      title: trans?.tech_gold?.products_a,
      desc: 'tech_gold.products_des_a'
    },
    {
      title: trans?.tech_gold?.products_b,
      desc: 'tech_gold.products_des_b'
    },
    {
      title: trans?.tech_gold?.products_c,
      desc: 'tech_gold.products_des_c'
    },
    {
      title: trans?.tech_gold?.products_d,
      desc: 'tech_gold.products_des_d'
    },
    {
      title: trans?.tech_gold?.products_e,
      desc: 'tech_gold.products_des_e'
    }],
    [{
      title: trans?.tech_gold?.tech_a,
      desc: 'tech_gold.tech_des_a'
    },
    {
      title: trans?.tech_gold?.tech_b,
      desc: 'tech_gold.tech_des_b'
    },
    {
      title: trans?.tech_gold?.tech_c,
      desc: 'tech_gold.tech_des_c'
    },
    {
      title: trans?.tech_gold?.tech_d,
      desc: 'tech_gold.tech_des_d'
    },
    {
      title: trans?.tech_gold?.tech_e,
      desc: 'tech_gold.tech_des_e'
    },
    {
      title: trans?.tech_gold?.tech_f,
      desc: 'tech_gold.tech_des_f'
    }],
    [{
      title: trans?.tech_gold?.policy_a,
      desc: 'tech_gold.policy_des_a'
    },
    {
      title: trans?.tech_gold?.policy_b,
      desc: 'tech_gold.policy_des_b'
    }],
    [{
      title: trans?.tech_gold?.guide_a,
      desc: 'tech_gold.guide_des_a'
    },
    {
      title: trans?.tech_gold?.guide_b,
      desc: 'tech_gold.guide_des_b'
    },
    {
      title: trans?.tech_gold?.guide_c,
      desc: 'tech_gold.guide_des_c'
    },

    {
      title: trans?.tech_gold?.guide_d,
      desc: 'tech_gold.guide_des_d'
    }]
  ];

  return (
    <>
      <MetaSeo {...dataSeo} />

      <div className="aff_slider">
        <div>
          <div className="aff_slider-image tech_slider_image">
            <div
              className="content_text content_text_aff"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className='aff_breadcrumb_component'>
                <BreadcrumbComponent title='Đồng vàng công nghệ' url='dong-vang-cong-nghe-hanagold'/>
              </div>
              <h1 className="he21jheqhw">{trans.tech_gold.slider_so}</h1>
              <div
                dangerouslySetInnerHTML={{
                  __html: trans.tech_gold.slider_title,
                }}
              ></div>
              {/* <p>
                Cơ hội gia tăng tài chính và phát triển bản thân, xây dựng đội
                ngũ kinh doanh chuyên nghiệp
              </p> */}
              <div className="aff_btn_res">
                <a
                  href="https://hanagold.vn/dong-vang-kim-khong-tuoc-24k"
                  target="_blank"
                >
                  {trans.tech_gold.buy_now}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tech_slide" data-aos="fade-up" data-aos-delay="800">
        <div className="tech_slide_container">
          <div className="tech_slide_content">
            <Slider {...setting} ref={ref}>
              {' '}
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_1.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_2.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_3.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_4.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_5.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_6.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_7.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_8.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_9.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div>
                <div className="tech_item_slide">
                  <img
                    src="/assets/img/tech/img_slide_10.png"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
            </Slider>
          </div>
          <div className="tech_control">
            <img
              src="/assets/img/tech/pre.svg"
              alt=""
              className="lazyload"
              onClick={() => {
                ref?.current?.slickPrev();
              }}
            />
            <img
              src="/assets/img/tech/next.svg"
              alt=""
              className="lazyload"
              onClick={() => {
                ref?.current?.slickNext();
              }}
            />
          </div>
        </div>
      </div>

      <div className="tech_section_one">
        <div className="tech_section_one_container">
          <div className="tech_section_one_content">
            <div data-aos="fade-right">
              <img
                src="/assets/img/tech/tech_a.png"
                alt=""
                className="lazyload"
              />
            </div>
            <div className="tech_section_one_content_text" data-aos="fade-left">
              <h2 className='sub-title'>{trans.tech_gold.first}</h2>
              <h3 className='sub-title-2nd'>{trans.tech_gold.gold_a}</h3>
              <p>
                {trans.tech_gold.gold_a_des}{' '}
                <span>NFC, Blockchain & Fintech</span>{' '}
                {trans.tech_gold.gold_b_des}
              </p>
              <a
                href="https://hanagold.vn/hanagold-cong-bo-tieu-chuan-dong-vang"
                target="_blank"
              >
                {trans.tech_gold.quality}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="tech_means">
        <div className="tech_means_container">
          <div className="tech_means_content">
            <div data-aos="fade-right">
              <div className="tech_means_content_img">
                <img
                  src="/assets/img/tech/t_means_a.png"
                  alt=""
                  className="t_means_dt lazyload"
                />
                <img
                  src="/assets/img/tech/1.png"
                  alt=""
                  className="t_means_mb lazyload"
                />
              </div>
              <div
                className="tech_means_content_text"
                dangerouslySetInnerHTML={{ __html: trans.tech_gold.meaning }}
              >
              </div>
            </div>
            <div data-aos="fade-left">
              <div
                className="tech_means_content_text"
                dangerouslySetInnerHTML={{ __html: trans.tech_gold.partner }}
              >
              </div>
              <div className="tech_means_content_img">
                <img
                  src="/assets/img/tech/t_means_b.png"
                  alt=""
                  className="t_means_dt lazyload"
                />
                <img
                  src="/assets/img/tech/2.png"
                  alt=""
                  className="t_means_mb lazyload"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tech_embeded">
        <div className="tech_embeded_container">
          <div className="tech_embeded_content" data-aos="fade-right">
            <h2 className='sub-title'>{trans?.tech_gold?.embed_tech}</h2>
            <img
              src="/assets/img/tech/tech_e_i.svg?t=1"
              alt=""
              className="tech_e_i_dt lazyload"
            />
            <img
              src="/assets/img/tech/tech_e_i_mb.svg?t=1"
              alt=""
              className="tech_e_i_mb lazyload"
            />
          </div>
        </div>
      </div>

      <div className="tech_gold">
        <div className="tech_gold_container">
          <div className="tech_gold_content">
            <h2 className='sub-title' data-aos="fade-up">{trans.tech_gold.gold_phoneix_t}</h2>
            <div className="oqwjfjawrahwfasnawheaw">
              <div>
                <div
                  className="text_center_a"
                  data-aos="fade-down-right"
                  data-aos-delay="800"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.gold_phoneix_des_a,
                  }}
                ></div>
                <img
                  src="/assets/img/tech/tech_g_i_lt.png"
                  alt=""
                  className="lazyload mw-3"
                  data-aos="fade-down"
                  data-aos-delay="500"
                />
                <img
                  src="/assets/img/tech/tech_g_i_a.png"
                  alt=""
                  className="lazyload jwbabs_a"
                  data-aos="fade-right"
                />
                <img
                  src="/assets/img/tech/tech_g_i_lb.png"
                  alt=""
                  className="lazyload mw-3 "
                  data-aos="fade-up"
                  data-aos-delay="500"
                />
                <div
                  className="text_center_a"
                  data-aos="fade-up-right"
                  data-aos-delay="800"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.gold_phoneix_des_b,
                  }}
                ></div>
              </div>
              <div>
                <div
                  className="text_center_b"
                  data-aos="fade-down-left"
                  data-aos-delay="800"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.gold_phoneix_des_c,
                  }}
                ></div>
                <img
                  src="/assets/img/tech/tech_g_i_rt.png"
                  alt=""
                  className="lazyload mw-3"
                  data-aos="fade-down"
                  data-aos-delay="500"
                />
                <img
                  src="/assets/img/tech/tech_g_i_b.png"
                  alt=""
                  className="lazyload jwbabs_b"
                  data-aos="fade-left"
                />
                <img
                  src="/assets/img/tech/tech_g_i_rb.png"
                  alt=""
                  className="lazyload mw-3"
                  data-aos="fade-up"
                  data-aos-delay="500"
                />

                <div
                  className="text_center_b"
                  data-aos="fade-up-left"
                  data-aos-delay="800"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.gold_phoneix_des_d,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tech_benefit tech_benefit_dt">
        <div className="tech_benefit_container">
          <div className="tech_benefit_content">
            <div className="tech_benefit_content_items" data-aos="fade-right">
              <div className="tech_benefit_content_item">
                <div
                  className="tect_iqjfjabf"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.benefit_a,
                  }}
                ></div>
                <div>
                  <img
                    src="/assets/img/tech/n_1.svg"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div className="tech_benefit_content_item">
                <div
                  className="tect_iqjfjabf"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.benefit_b,
                  }}
                ></div>
                <div>
                  <img
                    src="/assets/img/tech/n_2.svg"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div className="tech_benefit_content_item">
                <div
                  className="tect_iqjfjabf"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.benefit_c,
                  }}
                ></div>
                <div>
                  <img
                    src="/assets/img/tech/n_3.svg"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div className="tech_benefit_content_item">
                <div
                  className="tect_iqjfjabf"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.benefit_d,
                  }}
                ></div>
                <div>
                  <img
                    src="/assets/img/tech/n_4.svg"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
              <div className="tech_benefit_content_item">
                <div
                  className="tect_iqjfjabf"
                  dangerouslySetInnerHTML={{
                    __html: trans.tech_gold.benefit_e,
                  }}
                ></div>
                <div>
                  <img
                    src="/assets/img/tech/n_5.svg"
                    alt=""
                    className="lazyload"
                  />
                </div>
              </div>
            </div>
            <div data-aos="fade-left" className="vlaffjwrjsj">
              <h2 className='sub-title'>{trans.tech_gold.benefit}</h2>
              <img
                src="/assets/img/tech/tech_b_r.svg?t=1"
                alt=""
                className="lazyload"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="tech_benefit tech_benefit_mb">
        <div className="tech_benefit_mb_content">
          <h2>{trans.tech_gold.benefit}</h2>

          <div className="tech_benefit_mb_item">
            <div className="tech_benefit_mb_item_st">
              <img src="/assets/img/tech/n_1.svg" alt="" className="lazyload" />
            </div>
            <div className="tech_benefit_mb_item_text">
              <img
                src="/assets/img/tech/tech_b_cir_mb.png"
                alt=""
                className="lazyload"
              />
              <p>{trans.tech_gold.benefit_mb_a}</p>
            </div>
          </div>

          <div className="tech_benefit_mb_item">
            <div className="tech_benefit_mb_item_st">
              <img src="/assets/img/tech/n_2.svg" alt="" className="lazyload" />
            </div>
            <div className="tech_benefit_mb_item_text">
              <img
                src="/assets/img/tech/tech_b_cir_mb.png"
                alt=""
                className="lazyload"
              />
              <p>{trans.tech_gold.benefit_mb_b}</p>
            </div>
          </div>

          <div className="tech_benefit_mb_item">
            <div className="tech_benefit_mb_item_st">
              <img src="/assets/img/tech/n_3.svg" alt="" className="lazyload" />
            </div>
            <div className="tech_benefit_mb_item_text">
              <img
                src="/assets/img/tech/tech_b_cir_mb.png"
                alt=""
                className="lazyload"
              />
              <p>{trans.tech_gold.benefit_mb_c}</p>
            </div>
          </div>

          <div className="tech_benefit_mb_item">
            <div className="tech_benefit_mb_item_st">
              <img src="/assets/img/tech/n_4.svg" alt="" className="lazyload" />
            </div>
            <div className="tech_benefit_mb_item_text">
              <img
                src="/assets/img/tech/tech_b_cir_mb.png"
                alt=""
                className="lazyload"
              />
              <p>{trans.tech_gold.benefit_mb_d}</p>
            </div>
          </div>

          <div className="tech_benefit_mb_item">
            <div className="tech_benefit_mb_item_st">
              <img src="/assets/img/tech/n_5.svg" alt="" className="lazyload" />
            </div>
            <div className="tech_benefit_mb_item_text">
              <img
                src="/assets/img/tech/tech_b_cir_mb.png"
                alt=""
                className="lazyload"
              />
              <p>{trans.tech_gold.benefit_mb_e}</p>
            </div>
          </div>
        </div>
      </div>

      <FAQ
        title={trans.tech_gold.faq}
        sub_title={trans.tech_gold.faq_sub}
        arr_list_title_faq={arr_list_title_faq}
        arr_detail_fag={arr_detail_fag}
      />

      <div className="aff_app" id="aff_sign_up">
        <div className="aff_app_content mobile_app_content">
          <div className="aff_app_container" data-aos="fade-down">
            <div className="aff_app_t tech_app_t">
              <h2 className='sub-title'>{trans.tech_gold.community}</h2>
              <h3>{trans.tech_gold.des}</h3>

              <div
                className="buton_a buton_b buton_c"
                onClick={() => {
                  window.open('https://www.facebook.com/groups/hanagold');
                }}
              >
                <p>{trans.tech_gold.community_btn}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TextFooter text={text_footer}/>
    </>
  );
}

export default TechnologyGold;
